module.exports = __webpack_public_path__ + "img/icon-file.1d86a544.svg";